import React from 'react'
import { Button, Text } from '@sendoutcards/quantum-design-ui'
import { FlexColumn, FlexRow } from 'src/styled'
import { useSelector } from 'src/hooks'

const NowOrLater = (props: { onNow: () => void }) => {
  const { onNow } = props
  const { isMobile } = useSelector(s => s.window)
  return (
    <FlexColumn
      style={{
        justifyContent: 'center',
        marginBottom: isMobile ? '65px' : undefined,
      }}
    >
      <Text type="body">
        <span
          style={{ fontWeight: 'bold', fontFamily: 'Montserrat,sans-serif' }}
        >
          Your SendOutCards Affiliate account is not fully set-up.{' '}
        </span>
        We need a little more information. Do you want to finish it now or
        later?
      </Text>
      <FlexRow style={{ marginTop: '16px' }}>
        <div style={{ width: '30%' }}>
          <Button
            type="primary"
            title="Do It Now"
            onClick={onNow}
            fullWidth={true}
          />
        </div>
      </FlexRow>
    </FlexColumn>
  )
}

export default NowOrLater
